import { render, staticRenderFns } from "./Approvecen.vue?vue&type=template&id=daaaff96&"
import script from "./Approvecen.vue?vue&type=script&lang=js&"
export * from "./Approvecen.vue?vue&type=script&lang=js&"
import style0 from "./Approvecen.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports